import type { Except } from "type-fest";
import type { ImageReference } from "../images/image-reference";
import type { ImageUrl } from "../images/image-url";
import type { CustomerId } from "./customer-id";
import type { UserId } from "./user-id";

type UserReference = {
    _id: UserId | CustomerId;
    _type: "USER_REFERENCE";
    firstName?: string;
    lastName?: string;
    image?: ImageReference | ImageUrl;
};
const createUserReference = (
    params: Except<UserReference, "_type">,
): UserReference => {
    return {
        ...params,
        _type: "USER_REFERENCE",
    };
};

export { createUserReference };
export type { UserReference };
